import { call, put, takeLatest } from "redux-saga/effects";
import {
  billPaymentRequested,
  billPaymentSucceeded,
  billPaymentFailed,
} from "./billPaymentSlice";
import { BillPaymentPayload } from "features/bbps/biller/billerFlowTypes";
import billerService from "services/api.services/biller/billerService";
import { NormalizedError } from "services/axios.services/interceptors/commonInterceptors";

function* handleBillPayment(action: {
  type: string;
  payload: BillPaymentPayload;
}): Generator<any, any, any> {
  try {
    // const result: BillPaymentResult = yield call(
    //   payBillService,
    //   action.payload
    // );

    // console.log("handleBillPayment saga:", action.payload);

    const response = yield call(billerService.billPayment, action.payload);

    // console.log("handleBillPayment saga response: ", response);

    if (response.data?.reason?.responseCode !== "000") {
      const err: NormalizedError = {
        status: 422,
        message: response.reason?.responseReason || "Payment failed.",
        code: response.reason?.responseCode,
        url: "",
        method: "POST",
        raw: response,
      };
      yield put(billPaymentFailed(err));
      return;
    }

    yield put(billPaymentSucceeded(response.data));
  } catch (err: any) {
    const normalized: NormalizedError = err;
    yield put(billPaymentFailed(normalized));
  }
}

export function* billPaymentWatcher() {
  // console.log("billPaymentRequested in saga:", billPaymentRequested);

  yield takeLatest(billPaymentRequested.type, handleBillPayment);
}
